import React from 'react'
import { browserHistory } from 'react-router'

import NavLink from '../../Routes/NavLink'
import { modal } from '../../../core/utilities/modal';

export default class NavigatorBar extends React.Component {
    constructor(props) {
        super(props);
        var levelDown = parseInt(this.props.levelID);
        var levelUp = levelDown;

        var disabledUp = false;
        var disabledDown = false;

        if(levelDown > 1) {
            levelDown--;
        } else {
            //modal.showInfo("You've reached the bottom of the building!", "warning", "top", "center");
            disabledDown = true;
        }

        if(this.props.totalBuildingLevel && this.props.levelID > this.props.totalBuildingLevel) {
            //modal.showInfo("You've reached the top of the building!", "warning", "top", "center");
            disabledUp = true;
        } else {
            levelUp++;
        }

        this.state = {
            levelDown: levelDown,
            levelUp: levelUp,
            disabledUp: disabledUp,
            disabledDown: disabledDown
        }
    }

    componentDidMount() {
        jQuery(".navigator-bar").draggable();
    }
    componentWillUpdate(nextProps, nextState) {
        var levelDown = parseInt(nextProps.levelID);
        var disabledUp = false;
        var disabledDown = false;
        var levelUp = levelDown;
        if(levelDown > 1) {
            levelDown--;
        } else {
            //modal.showInfo("You've reached the bottom of the building!", "warning", "top", "center");
            disabledDown = true;
            if(levelDown <= 0) {
                browserHistory.goBack();
            }
        }

        if(nextProps.totalBuildingLevel && levelUp > nextProps.totalBuildingLevel) {
            disabledUp = true;
            //modal.showInfo("You've reached the top of the building!", "warning", "top", "center");
            if(nextProps.levelID > nextProps.totalBuildingLevel) {
                browserHistory.goBack();
            }
        } else {
            if(levelUp >= nextProps.totalBuildingLevel) {
                disabledUp = true;
            } else {
                levelUp++;
            }
        }

        nextState.levelDown = levelDown;
        nextState.levelUp = levelUp
        nextState.disabledDown = disabledDown;
        nextState.disabledUp = disabledUp;
    }

    componentDidUpdate() {}

    render(){
        const disabledUp = this.state.disabledUp;
        const disabledDown = this.state.disabledDown;
        return (
            <div class="onScreenWindow navigator-bar">
                <div class="col-sm-12 title"><i class="fa fa-wrench"></i></div>
                <div class="col-sm-12">
                    <div class="col-md-7 canvas-control">
                        <div class="controls">
                            <i class="fa fa-plus zoom-in tooltip_custom no_margin" onClick={this.props.zoomIn}>
                                <span data-toggle="tooltip" title="Zoom In"></span>
                            </i>
                            <i class="fa fa-arrow-right rotate-right tooltip_custom no_margin" onClick={this.props.rotateRight}>
                                <span data-toggle="tooltip" title="Turn Right"></span>
                            </i>
                            <i class="fa fa-arrow-left rotate-left tooltip_custom no_margin" onClick={this.props.rotateLeft}>
                                <span data-toggle="tooltip" title="Turn Left"></span>
                            </i>
                            <i class="fa fa-minus zoom-out tooltip_custom no_margin" onClick={this.props.zoomOut}>
                                <span data-toggle="tooltip" title="Zoom Out"></span>
                            </i>
                        </div>
                        <i class={"fa fa-arrows freeroam_button tooltip_custom no_margin " + this.props.toggles.freeRoam} onClick={this.props.toggleFreeRoam}>
                            <span data-toggle="tooltip" title="Free Roam"></span>
                        </i>
                    </div>
                    <div class="col-md-5 right-small">
                        <span class="birdseye" id="perspective"><i class="fa fa-eye tooltip_custom no_margin" onClick={this.props.updatePerspectiveCamera}>
                            <span data-toggle="tooltip" title="Bird's Eye View"></span>
                        </i></span>
                        <i class={"fa fa-pencil editmode tooltip_custom no_margin " + this.props.toggles.editMode} onClick={this.props.toggleEditMode}>
                            <span data-toggle="tooltip" title="Edit Mode"></span>
                        </i>
                        { disabledDown ? (
                            <i class="fa fa-level-down tooltip_custom no_margin disabled">
                                <span data-toggle="tooltip" title="Go Down Level"></span>
                            </i>
                        ) : (
                            <NavLink to={"/building/" + this.props.buildingID + "/level/" + this.state.levelDown}><i class="fa fa-level-down tooltip_custom no_margin">
                                <span data-toggle="tooltip" title="Go Down Level"></span></i>
                            </NavLink>
                        )}
                        { disabledUp ? (
                            <i class="fa fa-level-up tooltip_custom no_margin disabled"><span data-toggle="tooltip" title="Go Up Level"></span></i>
                        ) : (
                            <NavLink to={"/building/" + this.props.buildingID + "/level/" + this.state.levelUp}>
                                <i class="fa fa-level-up tooltip_custom no_margin"><span data-toggle="tooltip" title="Go Up Level"></span></i>
                            </NavLink>
                        )}
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Graphics/Editor/NavigatorBar.jsx